import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActionsDeleteDefault = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 21h12V7H6v14zM8 9h8v10H8V9zm7.5-5-1-1h-5l-1 1H5v2h14V4h-3.5z",
		fill: "#111"
	})
});
export default SvgActionsDeleteDefault;
